import { Fragment, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Dialog, Disclosure, Popover, Transition } from "@headlessui/react";
import {
  ArrowPathIcon,
  Bars3Icon,
  ChartPieIcon,
  CursorArrowRaysIcon,
  FingerPrintIcon,
  SquaresPlusIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";
import { ReactComponent as ChecklistIcon } from "../../assets/icons/checklist.svg";
import { ReactComponent as FAQIcon } from "../../assets/icons/faq.svg";
import { ReactComponent as ReviewsIcon } from "../../assets/icons/reviews.svg";
import { ReactComponent as ProcessIcon } from "../../assets/icons/process.svg";
import { ReactComponent as CanopyIcon } from "../../assets/icons/canopy_black.svg";
import {
  ChevronDownIcon,
  PhoneIcon,
  PlayCircleIcon,
  MagnifyingGlassIcon,
} from "@heroicons/react/20/solid";

import TourneyTentsLogoWithTagline from "../../assets/logos/tourneyTentsLogoWithTagline.png";
import FindTourneyCombobox from "./FindTourneyCombobox";

const howItWorksItems = [
  {
    name: "Process",
    description: "Quick overview of how it works",
    href: "howitworks/#process",
    icon: ProcessIcon,
  },
  {
    name: "Packages",
    description: "Learn about what we offer",
    href: "howitworks/#packages",
    icon: CanopyIcon,
  },

  // {
  //   name: "Reviews",
  //   description: "Hear from our happy customers",
  //   href: "/#reviews",
  //   icon: ReviewsIcon,
  // },
  {
    name: "FAQS",
    description: "Get your questions answered",
    href: "howitworks/#faq",
    icon: FAQIcon,
  },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function TopNav({
  cart,
  setCart,
  reservationStages,
  setReservationStages,
}) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  // if you click on logo from /root, it should scroll to top. If you click on it from anywhere else, it shoudl go to root /.
  // const handleLogoClick = () => {
  //   if (location.pathname === "/") {
  //     scrollToTop();
  //   } else {
  //     window.location.href = "/";
  //   }
  // };

  // const scrollToTop = () => {
  //   mobileMenuOpen && setMobileMenuOpen(false);
  //   window.scrollTo({
  //     top: 0,
  //     behavior: "smooth", // if you want a smooth scrolling effect
  //   });
  //   window.location.hash = ""; // reset the hash
  // };

  return (
    <header id="top" className="bg-white sticky top-0 z-40">
      <nav
        className="mx-auto flex max-w-7xl items-center justify-between lg:justify-start p-6 lg:px-8"
        aria-label="Global"
      >
        <div className="flex mr-8 -m-1.5 p-1.5">
          <Link
            to="home"
            className="text-sm font-semibold leading-6 text-gray-900"
            onClick={() => setMobileMenuOpen(false)}
          >
            <span className="sr-only">Tourney Tents</span>
            <img
              className="h-10 w-auto"
              src={TourneyTentsLogoWithTagline}
              alt=""
            />
          </Link>
        </div>
        <div className="flex lg:hidden">
          <button
            type="button"
            className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
            onClick={() => setMobileMenuOpen(true)}
          >
            <span className="sr-only">Open main menu</span>
            <Bars3Icon className="h-6 w-6" aria-hidden="true" />
          </button>
        </div>
        <Popover.Group className="hidden lg:flex lg:gap-x-10">
          <Popover className="relative">
            <Popover.Button className="flex items-center gap-x-1 text-sm font-semibold leading-6 text-gray-900">
              How's It Work?
              <ChevronDownIcon
                className="h-5 w-5 flex-none text-gray-400"
                aria-hidden="true"
              />
            </Popover.Button>

            <Transition
              as={Fragment}
              enter="transition ease-out duration-200"
              enterFrom="opacity-0 translate-y-1"
              enterTo="opacity-100 translate-y-0"
              leave="transition ease-in duration-150"
              leaveFrom="opacity-100 translate-y-0"
              leaveTo="opacity-0 translate-y-1"
            >
              <Popover.Panel className="absolute -left-8 top-full z-10 mt-3 w-screen max-w-md overflow-hidden rounded-3xl bg-white shadow-lg ring-1 ring-gray-900/5">
                <div className="p-4">
                  {howItWorksItems.map((item) => (
                    <div
                      key={item.name}
                      className="group relative flex items-center gap-x-6 rounded-lg p-4 text-sm leading-6 hover:bg-gray-50"
                    >
                      <div className="flex h-11 w-11 flex-none items-center justify-center rounded-lg bg-gray-50 group-hover:bg-white">
                        <item.icon
                          className="h-6 w-6 text-gray-600 group-hover:text-ttNavy-600"
                          aria-hidden="true"
                        />
                      </div>
                      <div className="flex-auto">
                        <Link
                          to={item.href}
                          className="block font-semibold text-gray-900"
                          onClick={() => setMobileMenuOpen(false)}
                        >
                          {item.name}
                          <span className="absolute inset-0" />
                        </Link>
                        <p className="mt-1 text-gray-600">{item.description}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </Popover.Panel>
            </Transition>
          </Popover>
          <div className="hidden lg:flex lg:gap-x-10">
            {/* <Link
              to="howitworks"
              className="text-sm font-semibold leading-6 text-gray-900"
              onClick={() => setMobileMenuOpen(false)}
            >
              How's It Work?
            </Link> */}
            {/* <Link
            to="reservations"
            className="text-sm font-semibold leading-6 text-gray-900"
            onClick={() => setMobileMenuOpen(false)}
          >
            See Us In Action
          </Link> */}
            <Link
              to="reservations"
              className="text-sm font-semibold leading-6 text-gray-900"
              onClick={() => setMobileMenuOpen(false)}
            >
              Book Your Tents
            </Link>
            <Link
              to="storage"
              className="text-sm font-semibold leading-6 text-gray-900"
              onClick={() => setMobileMenuOpen(false)}
            >
              Store Your Tents
            </Link>
            <Link
              to="about"
              className="text-sm font-semibold leading-6 text-gray-900"
              onClick={() => setMobileMenuOpen(false)}
            >
              About Us
            </Link>
            <Link
              to="contact"
              className="text-sm font-semibold leading-6 text-gray-900"
              onClick={() => setMobileMenuOpen(false)}
            >
              Contact Us
            </Link>
            <a
              href="https://www.moq1.com/haymakerpromotions/tourney-tents"
              target="_blank"
              rel="noreferrer"
              className="text-sm font-medium leading-6 text-gray-500 hover:text-gray-900 flex items-center gap-x-1"
            >
              <svg fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="h-4 w-4">
                <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 21v-7.5a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 .75.75V21m-4.5 0H2.36m11.14 0H18m0 0h3.64m-1.39 0V9.349M3.75 21V9.349m0 0a3.001 3.001 0 0 0 3.75-.615A2.993 2.993 0 0 0 9.75 9.75c.896 0 1.7-.393 2.25-1.016a2.993 2.993 0 0 0 2.25 1.016c.896 0 1.7-.393 2.25-1.016a3.001 3.001 0 0 0 3.75.614m-16.5 0a3.004 3.004 0 0 1-.621-4.72L4.318 3.44A1.5 1.5 0 0 1 5.378 3h13.243a1.5 1.5 0 0 1 1.06.44l1.19 1.189a3 3 0 0 1-.621 4.72M6.75 18h3.75a.75.75 0 0 0 .75-.75V13.5a.75.75 0 0 0-.75-.75H6.75a.75.75 0 0 0-.75.75v3.75c0 .414.336.75.75.75Z" />
              </svg>
              Merch
            </a>
          </div>
        </Popover.Group>

        {/* INFO Tournament Search Combobox 
        <div className="hidden lg:flex lg:flex-1 lg:justify-end">
          <div className="w-full max-w-lg lg:max-w-xs items-center">
            // Don't show combobox if on reservations screen
            {location.pathname !== "/reservations" && (
              <>
                <label htmlFor="search" className="sr-only">
                  Search Upcoming Events
                </label>
                <FindTourneyCombobox
                  cart={cart}
                  reservationStages={reservationStages}
                  setCart={setCart}
                  setReservationStages={setReservationStages}
                  setMobileMenuOpen={setMobileMenuOpen}
                />
              </>
            )}
          </div>
        </div> */}
      </nav>
      <Dialog
        as="div"
        className="lg:hidden"
        open={mobileMenuOpen}
        onClose={setMobileMenuOpen}
      >
        <div className="fixed inset-0 z-10" />
        <Dialog.Panel className="fixed inset-y-0 right-0 z-40 w-full overflow-y-auto bg-white px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
          <div className="flex items-center justify-between">
            <Link
              to="home"
              className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
              onClick={() => setMobileMenuOpen(false)}
            >
              <div className="-m-1 p-1.5">
                <span className="sr-only">Tourney Tents</span>
                <img
                  className="h-12 w-auto"
                  src={TourneyTentsLogoWithTagline}
                  alt=""
                />
              </div>
            </Link>
            <button
              type="button"
              className="-m-2.5 rounded-md p-2.5 text-gray-700"
              onClick={() => setMobileMenuOpen(false)}
            >
              <span className="sr-only">Close menu</span>
              <XMarkIcon className="h-6 w-6" aria-hidden="true" />
            </button>
          </div>
          <div className="mt-6 flow-root">
            <div className="-my-6 divide-y divide-gray-500/10">
              <div className="space-y-2 py-6">
                <Disclosure as="div" className="-mx-3">
                  {({ open }) => (
                    <>
                      <Disclosure.Button className="flex w-full items-center justify-between rounded-lg py-2 pl-3 pr-3.5 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50">
                        How's It Work?
                        <ChevronDownIcon
                          className={classNames(
                            open ? "rotate-180" : "",
                            "h-5 w-5 flex-none"
                          )}
                          aria-hidden="true"
                        />
                      </Disclosure.Button>
                      <Disclosure.Panel className="mt-2 space-y-2">
                        {howItWorksItems.map((item) => (
                          <Disclosure.Button
                            key={item.name}
                            as={Link}
                            to={item.href}
                            className="block rounded-lg py-2 pl-6 pr-3 text-sm font-semibold leading-7 text-gray-900 hover:bg-gray-50"
                            onClick={() => setMobileMenuOpen(false)}
                          >
                            {item.name}
                          </Disclosure.Button>
                        ))}
                      </Disclosure.Panel>
                    </>
                  )}
                </Disclosure>
                {/* <Link
                  to="howitworks"
                  className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {" "}
                  How's It Work?
                </Link> */}
                {/* <Link
                  to="gallery"
                  onClick={() => setMobileMenuOpen(false)}
                  className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
                >
                  See Us In Action
                </Link> */}
                <Link
                  to="reservations"
                  className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Book Your Tents
                </Link>
                <Link
                  to="storage"
                  className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Store Your Tents
                </Link>
                <Link
                  to="about"
                  onClick={() => setMobileMenuOpen(false)}
                  className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
                >
                  About Us
                </Link>
                <Link
                  to="contact"
                  onClick={() => setMobileMenuOpen(false)}
                  className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
                >
                  Contact Us
                </Link>
                <a
                  href="https://www.moq1.com/haymakerpromotions/tourney-tents"
                  target="_blank"
                  rel="noreferrer"
                  onClick={() => setMobileMenuOpen(false)}
                  className="-mx-3 flex items-center gap-x-2 rounded-lg px-3 py-2 text-base font-medium leading-7 text-gray-500 hover:bg-gray-50"
                >
                  <svg fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="h-5 w-5">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 21v-7.5a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 .75.75V21m-4.5 0H2.36m11.14 0H18m0 0h3.64m-1.39 0V9.349M3.75 21V9.349m0 0a3.001 3.001 0 0 0 3.75-.615A2.993 2.993 0 0 0 9.75 9.75c.896 0 1.7-.393 2.25-1.016a2.993 2.993 0 0 0 2.25 1.016c.896 0 1.7-.393 2.25-1.016a3.001 3.001 0 0 0 3.75.614m-16.5 0a3.004 3.004 0 0 1-.621-4.72L4.318 3.44A1.5 1.5 0 0 1 5.378 3h13.243a1.5 1.5 0 0 1 1.06.44l1.19 1.189a3 3 0 0 1-.621 4.72M6.75 18h3.75a.75.75 0 0 0 .75-.75V13.5a.75.75 0 0 0-.75-.75H6.75a.75.75 0 0 0-.75.75v3.75c0 .414.336.75.75.75Z" />
                  </svg>
                  Merch
                </a>
              </div>
              {/* INFO Mobile Tournament Search Combobox
              <div className="py-6">
                <div className="w-full max-w-lg lg:max-w-sm">
                  {location.pathname !== "/reservations" && (
                    <>
                      <label htmlFor="search" className="sr-only">
                        Search Upcoming Events
                      </label>
                      <FindTourneyCombobox
                        cart={cart}
                        reservationStages={reservationStages}
                        setCart={setCart}
                        setReservationStages={setReservationStages}
                        setMobileMenuOpen={setMobileMenuOpen}
                      />
                    </>
                  )}
                </div>
              </div> */}
            </div>
          </div>
        </Dialog.Panel>
      </Dialog>
    </header>
  );
}
